<template>
    <span v-if="mostrarBtnProcessarReprovar">
        <!-- <b-button
            variant="primary"
            @click.stop="confirmarProcessarReprovar('A')"
            class="mr-2"
        >
            <span> <i class="fa fa-check-circle"></i> Iniciar processamento </span>
        </b-button> -->
        <b-button variant="danger" @click.stop="abrirDetalheReprovacao()">
            <span> <i class="fa fa-times-circle"></i> Reprovar </span>
        </b-button>
        <b-modal
            id="modalDetalheReprovacao"
            v-model="mostrarModalDetalheReprovacao"
        >
            <div slot="modal-title">
                Registro de Pagamento - Detalhe da Reprovação
            </div>
            <app-erros-box
                :erros="erros"
                v-if="erros.length > 0"
            ></app-erros-box>
            <b-row>
                <b-col sm="12">
                    <b-form-group>
                        <label for="contato">Detalhe da Reprovação</label>
                        <b-form-textarea
                            v-model="detalheReprovacao"
                            :rows="4"
                            @input="$v.detalheReprovacao.$touch()"
                            :state="$v.detalheReprovacao.$error ? false : null"
                        ></b-form-textarea>
                        <b-form-invalid-feedback
                            >O detalhe da reprovação é
                            obrigatório</b-form-invalid-feedback
                        >
                    </b-form-group>
                </b-col>
            </b-row>
            <div slot="modal-footer">
                <b-button
                    variant="secondary"
                    @click.stop="fecharDetalheReprovacao()"
                    >Cancelar</b-button
                >
                <b-button
                    variant="danger"
                    :disabled="$v.$invalid"
                    @click.stop="confirmarProcessarReprovar('R')"
                    class="ml-2"
                >
                    <span> <i class="fa fa-times-circle"></i> Reprovar </span>
                </b-button>
            </div>
        </b-modal>
    </span>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import { finalizacoesStatus } from './FinalizacoesStatus'
import { perfil } from '../../SgfPerfis.js'

export default {
    props: {
        finalizacao: {
            type: Object,
            default: () => ({})
        },

        finalizacoesServicos: {
            type: Object,
            default: () => ({})
        }
    },

    data() {
        return {
            erros: [],
            mostrarModalDetalheReprovacao: false,
            detalheReprovacao: ''
        }
    },

    methods: {
        abrirDetalheReprovacao() {
            this.mostrarModalDetalheReprovacao = true
        },

        fecharDetalheReprovacao() {
            this.mostrarModalDetalheReprovacao = false
            this.detalheReprovacao = ''
        },

        confirmarProcessarReprovar(acao) {
            let acaoTitulo
            let acaoMensagem
            if (acao === 'A') {
                acaoTitulo = 'Processar'
                acaoMensagem = 'o processamento'
            } else {
                acaoTitulo = 'Reprovar'
                acaoMensagem = 'a reprovação'
            }
            this.$swal({
                title: `${acaoTitulo} Registro de Pagamento`,
                html: `Confirma ${acaoMensagem} do registro de pagamento?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then((result) => {
                if (result.value) {
                    this.processarReprovar(acao)
                }
            })
        },

        processarReprovar(acao) {
            this.$store.dispatch('addRequest')
            let aprovaReprovaFinalizacaoDto = {
                finalizacaoId: this.$route.params.finalizacaoId,
                acao: acao,
                detalheReprovacao: this.detalheReprovacao,
                perfil: perfil.FINANCEIRO
            }
            this.finalizacoesServicos
                .aprovarReprovarFinalizacao(aprovaReprovaFinalizacaoDto)
                .then((response) => {
                    if (response) {
                        if (response.success) {
                            this.$toast.success(
                                'Registro atualizado com sucesso!',
                                'OK',
                                this.$toastConfig.success
                            )
                            this.$emit('obterFinalizacaoAtualizada')
                            this.fecharDetalheReprovacao()
                        } else {
                            this.$toast.error(
                                'Erro ao atualizar registro de pagamento!!!',
                                'ERROR',
                                this.$toastConfig.error
                            )
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
        }
    },

    computed: {
        mostrarBtnProcessarReprovar() {
            return this.$route.name == 'Uabs_Finalizacoes_Detalhar'
                && this.$temAcesso('CRED-UFI-FIN-00') 
                && this.finalizacao.status === finalizacoesStatus.AGUARDANDO_SETOR_FINANCEIRO
        },
    },

    validations: {
        detalheReprovacao: {
            required
        }
    }
}
</script>
